module.exports = __webpack_public_path__ + "img/bg_onepack_pad.9c2dcbe1.png";